export default {
  install: function(Vue) {
    var webSocket = new WebSocket("wss://127.0.0.1:13579/");
    var heartbeat_msg = "--heartbeat--";
    var heartbeat_interval = null;
    var missed_heartbeats = 0;
    var missed_heartbeats_limit_min = 3;
    var missed_heartbeats_limit_max = 50;
    var missed_heartbeats_limit = missed_heartbeats_limit_min;
    var callback = null;
    //var rw = null;
    webSocket.onopen = function(event) {
      if (heartbeat_interval === null) {
        missed_heartbeats = 0;
        heartbeat_interval = setInterval(Vue.prototype.$pingLayer, 2000);
      }
      if (event.wasClean) {
        console.log("connection has been closed");
      } else {
        console.log("Connection error NCALayer");
      }
    };
    webSocket.onerror = function(error) {
      console.log("Connection error NCALayer", error);
    };
    webSocket.onclose = function(event) {
      if (event.wasClean) {
        console.log("connection has been closed");
      } else {
        console.log("Connection error NCALayer");
      }
    };

    webSocket.onmessage = function(event) {
      if (event.data === heartbeat_msg) {
        missed_heartbeats = 0;
        return;
      }

      var result = JSON.parse(event.data);

      if (result != null) {
        var rw = {
          code: result["code"],
          message: result["message"],
          responseObject: result["responseObject"],
          getResult: function() {
            return this.result;
          },
          getMessage: function() {
            return this.message;
          },
          getResponseObject: function() {
            return this.responseObject;
          },
          getCode: function() {
            return this.code;
          }
        };
        callback && window[callback](rw);
      }

      Vue.prototype.$setMissedHeartbeatsLimitToMin();
    };

    Vue.prototype.$reconnectLayer = function() {
      if (webSocket.readyState == 3) {
        webSocket = new WebSocket("wss://127.0.0.1:13579/");
      }
    };

    Vue.prototype.$isLayerConnected = function() {
      return webSocket.readyState == 1;
    };

    Vue.prototype.$setMissedHeartbeatsLimitToMax = function() {
      missed_heartbeats_limit = missed_heartbeats_limit_max;
    };

    Vue.prototype.$setMissedHeartbeatsLimitToMin = function() {
      missed_heartbeats_limit = missed_heartbeats_limit_min;
    };

    Vue.prototype.$openDialog = function() {
      alert(
        "Ошибка при подключений к прослойке. Убедитесь что программа запущена и нажмите ОК"
      );
    };

    Vue.prototype.$pingLayer = function() {
      try {
        missed_heartbeats++;
        if (missed_heartbeats >= missed_heartbeats_limit) {
          throw new Error("Too many missed heartbeats.");
        }
        webSocket.send(heartbeat_msg);
      } catch (e) {
        clearInterval(heartbeat_interval);
        heartbeat_interval = null;
        //console.warn("Closing connection. Reason: " + e.message);

        webSocket.close();
      }
    };

    Vue.prototype.$getActiveTokens = function(callBack) {
      // console.log("getActiveTokents() called");
      var getActiveTokens = {
        module: "kz.gov.pki.knca.commonUtils",
        method: "getActiveTokens"
      };
      callback = callBack;
      Vue.prototype.$setMissedHeartbeatsLimitToMax();
      webSocket.send(JSON.stringify(getActiveTokens));
    };

    Vue.prototype.$getKeyInfo = function(storageName, callBack) {
      var getKeyInfo = {
        module: "kz.gov.pki.knca.commonUtils",
        method: "getKeyInfo",
        args: [storageName]
      };
      callback = callBack;
      Vue.prototype.$setMissedHeartbeatsLimitToMax();
      // console.log(webSocket);
      if (webSocket.readyState === webSocket.CLOSED && webSocket.CLOSING) {
        Vue.prototype.$openDialog();
      } else {
        // console.log(JSON.stringify(getKeyInfo));
        webSocket.send(JSON.stringify(getKeyInfo));
      }
    };

    Vue.prototype.$signXml = function(
      storageName,
      keyType,
      xmlToSign,
      callBack
    ) {
      var signXml = {
        module: "kz.gov.pki.knca.commonUtils",
        method: "signXml",
        args: [storageName, keyType, xmlToSign, "", ""]
      };
      callback = callBack;
      Vue.prototype.$setMissedHeartbeatsLimitToMax();

      if (webSocket.readyState == 1) {
        webSocket.send(JSON.stringify(signXml));
      }
    };

    Vue.prototype.$createCMSSignatureFromFile = function(
      storageName,
      keyType,
      filePath,
      flag,
      callBack
    ) {
      var createCMSSignatureFromFile = {
        module: "kz.gov.pki.knca.commonUtils",
        method: "createCMSSignatureFromFile",
        args: [storageName, keyType, filePath, flag]
      };
      callback = callBack;
      Vue.prototype.$setMissedHeartbeatsLimitToMax();
      webSocket.send(JSON.stringify(createCMSSignatureFromFile));
    };

    Vue.prototype.$showFileChooser = function(
      fileExtension,
      currentDirectory,
      callBack
    ) {
      var showFileChooser = {
        module: "kz.gov.pki.knca.commonUtils",
        method: "showFileChooser",
        args: [fileExtension, currentDirectory]
      };
      callback = callBack;
      Vue.prototype.$setMissedHeartbeatsLimitToMax();
      webSocket.send(JSON.stringify(showFileChooser));
    };

    Vue.prototype.$getKeyInfoCall = function() {
      // console.log("getKeyInfoCall");
    };
    /**
     * NCALayer call functions
     */
    //var btneds = "#btn-eds";
    Vue.prototype.$getActiveTokensCall = function() {
      Vue.prototype.$getActiveTokens("getActiveTokensBack");
    };

    Vue.prototype.$getActiveTokensBackfunction = function(result) {
      if (result["code"] === "500")
        //{
        alert(result["message"]);
      // } else if (result['code'] === "200") {
      //     var listOfTokens = result['responseObject'];
      //     $('#storageSelect').empty();
      //     $('#storageSelect').append('<option value="PKCS12">ЭЦП</option>');
      //     for (var i = 0; i < listOfTokens.length; i++) {
      //         $('#storageSelect').append('<option value="' + listOfTokens[i] + '">' + listOfTokens[i] + '</option>');
      //     }
      // }
    };

    Vue.prototype.$getKeyInfoCall = function() {
      var selectedStorage = $("#storageSelect").val();
      Vue.prototype.$getKeyInfo(selectedStorage, "getKeyInfoBack");
    };

    Vue.prototype.$getKeyInfoBack = window["getKeyInfoBack"] = function(
      result
    ) {
      // console.log("getKeyInfoBack() called");
      if (result["code"] === "500") {
        alert(result["message"]);
        return false;
      } else if (result["code"] === "200") {
        var vdsModal = $(".ecp-modal-container");
        var res = result["responseObject"];
        var alias = res["alias"];
        //$("#alias").val(alias);

        var keyId = res["keyId"];
        //$("#keyId").val(keyId);

        var algorithm = res["algorithm"];
        //$("#algorithm").val(algorithm);

        var subjectCn = res["subjectCn"];
        if (subjectCn) {
          vdsModal.find("#name").val(subjectCn);
        }

        var issuerCn = res["issuerCn"];
        vdsModal.find("#publisherName").val(issuerCn);

        var sn = res["subjectDn"];
        if (sn) {
          if (sn.split(",")[8]) {
            let bsn = sn.split(",")[8].split("=")[1];
            var bin = bsn.replace(/[^\d]/g, "");
            if (bin.length > 0) {
              vdsModal.find("#bin").val(bin);
              vdsModal
                .find("#bin")
                .closest(".input-field")
                .toggleClass("hidden");
            }
          }

          sn = sn.split(",")[2].split("=")[1];
          //            console.log(sn.replace(/[^\d]/g,""));
          var iin = sn.replace(/[^\d]/g, "");
          // $("#subjIIN").val(iin);
          vdsModal.find("#iin").val(iin);
        }

        var serialNumber = res["serialNumber"];
        if (serialNumber) {
          //$("#subjectSerial").val(serialNumber);
          //console.log(serialNumber);
          vdsModal.find("#serialNumber").val(serialNumber);
          //check sn in revocation list
        }

        var dateAfter = new Date(Number(res["certNotAfter"]));

        var dateBefore = new Date(Number(res["certNotBefore"]));

        if (dateAfter && dateBefore) {
          vdsModal
            .find("#validity")
            .val(
              dateBefore.toLocaleString() + " - " + dateAfter.toLocaleString()
            );
        }

        var authorityKeyIdentifier = res["authorityKeyIdentifier"];
        vdsModal.find("#authorityKeyIdentifier").val(authorityKeyIdentifier);

        vdsModal.find("#algorithm").val(algorithm);

        var pem = res["pem"];
        vdsModal.find("#pem").val(btoa(pem));
        if (window.location.pathname == "/instruction/post-order") {
          return true;
        }
        if (sn && serialNumber) {
          //console.log("result is true");
          vdsModal.toggleClass("hidden");
          return true;
        } else {
          return false;
        }
      }
    };

    Vue.prototype.$signAuthXmlBack = window["signAuthXmlBack"] = function(
      result
    ) {
      if (result["code"] === "500") {
        alert(result["message"]);
      } else if (result["code"] === "200") {
        var res = result["responseObject"];
        Vue.prototype.$setValueInObject(
          Vue.signModel,
          Vue.signModelAttribute,
          res
        );
        Vue.signModel.loginByEds();
      }
    };

    Vue.prototype.$signXmlCall = function(
      xmlToSign,
      signModel,
      signModelAttribute
    ) {
      Vue.prototype.$signXml("PKCS12", "SIGNATURE", xmlToSign, "signXmlBack");
      Vue.signModel = signModel;
      Vue.signModelAttribute = signModelAttribute;
    };

    Vue.signModel = null;
    Vue.signModelAttribute = null;

    Vue.prototype.$signXmlBack = window["signXmlBack"] = function(result) {
      if (result["code"] === "500") {
        alert(result["message"]);
      } else if (result["code"] === "200") {
        var res = result["responseObject"];
        Vue.prototype.$setValueInObject(
          Vue.signModel,
          Vue.signModelAttribute,
          res
        );
        Vue.signModel.checkSign();
      }
    };

    Vue.prototype.$signXmlAuthCall = function(
      xmlToSign,
      signModel,
      signModelAttribute
    ) {
      Vue.signModel = signModel;
      Vue.signModelAttribute = signModelAttribute;
      Vue.prototype.$signXml("PKCS12", "AUTH", xmlToSign, "signAuthXmlBack");
    };

    Vue.prototype.$createCMSSignatureFromFileCall = function() {
      var selectedStorage = $("#storageSelect").val();
      var flag = $("#flag").is(":checked");
      var filePath = $("#filePath").val();
      if (filePath !== null && filePath !== "") {
        Vue.prototype.$createCMSSignatureFromFile(
          selectedStorage,
          "SIGNATURE",
          filePath,
          flag,
          "createCMSSignatureFromFileBack"
        );
      } else {
        alert("Не выбран файл для подписи!");
      }
    };

    Vue.prototype.$createCMSSignatureFromFileBack = function(result) {
      //$.unblockUI();
      if (result["code"] === "500") {
        alert(result["message"]);
      } else if (result["code"] === "200") {
        var res = result["responseObject"];
        $("#createdCMS").val(res);
      }
    };

    Vue.prototype.$showFileChooserCall = function() {
      Vue.prototype.$showFileChooser("ALL", "", "showFileChooserBack");
    };

    Vue.prototype.$showFileChooserBack = function(result) {
      if (result["code"] === "500") {
        alert(result["message"]);
      } else if (result["code"] === "200") {
        var res = result["responseObject"];
        $("#filePath").val(res);
      }
    };

    Vue.prototype.$setValueInObject = function(
      object,
      objectKey,
      val,
      returnValue = false
    ) {
      if (!Object.prototype.forEach) {
        Object.defineProperty(Object.prototype, "forEach", {
          value: function(callback, thisArg) {
            if (this == null) {
              throw new TypeError("Not an object");
            }
            thisArg = thisArg || window;
            for (var key in this) {
              if (this.hasOwnProperty(key)) {
                callback.call(thisArg, this[key], key, this);
              }
            }
          }
        });
      }
      object.forEach(function(key, value) {
        if (value === objectKey) {
          object[value] = val;
          if (returnValue === true) {
            return object[value];
          }
        }
      });
      return object;
    };
  }
};
